module.exports = __webpack_public_path__ + "static/img/douyinYili.fc53472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/douyinYili.jpg
// module id = fW9A
// module chunks = 0